import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
    {
        path: "/view",
        name: "VIEW",
        component: () => import("../views/view/index.vue")
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/login.vue")
    },
    {
        path: "/",
        component: () => import("../views/index.vue"),
        redirect: "/news",
        children: [
            // 新闻中心
            {
                path: "news",
                name: "news",
                redirect: {
                    name: "newList"
                },
                component: () => import("../views/news/index.vue"),
                children: [
                    {
                        path: "newList",
                        name: "newList",
                        component: () => import("../views/news/new-list.vue")
                    },
                    {
                        path: "view",
                        name: "view",
                        component: () => import("../views/news/new-view.vue")
                    }
                ]
            },
            // 领导团队
            {
                path: "lead",
                name: "lead",
                redirect: {
                    name: "leaderList"
                },
                component: () => import("../views/leaders/index.vue"),
                children: [
                    {
                        path: "leaderList",
                        name: "leaderList",
                        component: () => import("../views/leaders/leader-list.vue")
                    }
                ]
            },
            // 新书推荐
            {
                path: "book",
                name: "book",
                redirect: {
                    name: "bookList"
                },
                component: () => import("../views/books/index.vue"),
                children: [
                    {
                        path: "bookList",
                        name: "bookList",
                        component: () => import("../views/books/book-list.vue")
                    },
                    {
                        path: "view",
                        name: "bookView",
                        component: () => import("../views/books/book-view"),
                    },
                ]
            },
            // 用户管理
            {
                path: "user",
                name: "user",
                redirect: {
                    name: "userList"
                },
                component: () => import("../views/users/index.vue"),
                children: [
                    {
                        path: "userList",
                        name: "userList",
                        component: () => import("../views/users/user-list.vue")
                    }
                ]
            },
            // 联系我们
            {
                path: "contact",
                name: "contact",
                redirect: {
                    name: "contactList"
                },
                component: () => import("../views/contact/index.vue"),
                children: [
                    {
                        path: "contactList",
                        name: "contactList",
                        component: () => import("../views/contact/contact-list.vue")
                    }
                ]
            },
            // 轮播管理
            {
                path: "banner",
                name: "BANNER",
                redirect: {
                    name: "addBanner"
                },
                component: () => import("../views/banner/index.vue"),
                children: [
                    {
                        path: "addBanner",
                        name: "addBanner",
                        component: () => import("../views/banner/add-banner.vue")
                    }
                ]
            },
            // 荣誉表扬
            {
                path: "honor",
                name: "HONOR",
                redirect: {
                    name: "honorList"
                },
                component: () => import("../views/honor/index.vue"),
                children: [
                    {
                        path: "honorList",
                        name: "honorList",
                        component: () => import("../views/honor/honor-list.vue")
                    }
                ]
            },
            // 联系我们邮箱配置
            {
                path: "email",
                name: "EMAIL",
                redirect: {
                    name: "LIST"
                },
                component: () => import("../views/email/index.vue"),
                children: [
                    {
                        path: "list",
                        name: "LIST",
                        component: () => import("../views/email/list.vue")
                    }
                ]
            },
            // 招聘管理
            {
                path: "offer",
                name: "offer",
                redirect: {
                    name: "offerList"
                },
                component: () => import("../views/offer/index.vue"),
                children: [
                    {
                        path: "offerList",
                        name: "offerList",
                        component: () => import("../views/offer/offer-list.vue")
                    },
                    // {
                    //     path: "view",
                    //     name: "view",
                    //     component: () => import("../views/offer/offer-view.vue")
                    // }
                ]
            },
            // 申请人管理
            {
                path: "applicant",
                name: "applicant",
                redirect: {
                    name: "applicantList"
                },
                component: () => import("../views/applicant/index.vue"),
                children: [
                    {
                        path: "applicantList",
                        name: "applicantList",
                        component: () => import("../views/applicant/applicant-list.vue")
                    },
                    // {
                    //     path: "view",
                    //     name: "view",
                    //     component: () => import("../views/applicant/applicant-view.vue")
                    // }
                ]
            },
            // 媒体
            {
                path: "media",
                name: "MEDIA",
                redirect: {
                    name: "MEDIALIST"
                },
                component: () => import("../views/media/index.vue"),
                children: [
                    {
                        path: "medialist",
                        name: "MEDIALIST",
                        component: () => import("../views/media/list.vue")
                    }
                ]
            }
        ]
    }
];
const router = new VueRouter({
    routes,
    mode: "history",
    base: process.env.BASE_URL
})

router.beforeEach((to, from, next) => {
    let token = sessionStorage.getItem('token');
    if (to.name === 'VIEW') {
        next();
        return;
    }
    if (to.name !== "login" && !token) {
        next({path: "/login", replace: true})
    } else if (token && to.name === "login") {
        next({path: "/", replace: true})
    } else {
        next()
    }
});

export default router
